module.exports = __webpack_public_path__ + "static/img/008.823b643c.png";